/**
 * Sparkline: a tendencia dentro de um cartao de KPI (RNF15).
 *
 * Sem eixo, sem rotulo, sem tooltip -- e um traco de contexto ao lado do
 * numero, nao um grafico. Quem quiser o valor por dia tem o grafico de
 * tendencia logo abaixo, com tabela. Linha de 2px, ponto final de 8px com anel
 * da superficie, area a 10%: as mesmas regras de marca do grafico grande.
 *
 * Aria: `img` com um texto que resume a serie, porque a forma nao tem leitura
 * por leitor de tela e o numero do cartao ja e lido ao lado.
 */
export function Sparkline({
  values,
  label,
  className = 'h-10 w-28',
}: {
  readonly values: readonly number[];
  readonly label: string;
  readonly className?: string;
}): JSX.Element | null {
  if (values.length < 2) {
    return null;
  }
  const width = 112;
  const height = 40;
  const pad = 4;
  const max = Math.max(...values, 1);
  const stepX = (width - pad * 2) / (values.length - 1);
  const y = (v: number): number => height - pad - (v / max) * (height - pad * 2);

  const points = values.map((v, i) => `${(pad + i * stepX).toFixed(1)},${y(v).toFixed(1)}`);
  const line = `M${points.join(' L')}`;
  const area = `${line} L${(pad + (values.length - 1) * stepX).toFixed(1)},${height - pad} L${pad},${height - pad} Z`;
  const last = values[values.length - 1] ?? 0;
  const lastX = pad + (values.length - 1) * stepX;

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      className={className}
      role="img"
      aria-label={label}
      preserveAspectRatio="none"
    >
      <path d={area} className="fill-series-1/10" />
      <path d={line} className="stroke-series-1" strokeWidth={2} fill="none" strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
      <circle cx={lastX} cy={y(last)} r={4} className="fill-series-1 stroke-surface" strokeWidth={2} vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
